export default "__VITE_ASSET__A70jq$83__"